import { Constructor, DoorType } from "../@types/shared";
import {
    DoubleSlidingDoors,
    DoubleSwingDoors,
    KompasDoubleFramedDoorCode,
    KompasSingleFramedDoorCode,
    SingleSlidingDoors,
    SingleSwingDoors,
    SteelArchDoubleSwingDoorsCode,
    SteelArchSingleSwingDoorCode,
    SteelDoubleSlidingDoorsCode,
    SteelDoubleSwingDoorsCode,
    SteelFoldingDoorsCode,
    SteelMultiSlidingDoorsCode,
    SteelSingleSlidingDoorCode,
    SteelSingleSwingDoorCode,
} from "../constants";
import { DoorHardwareCreationStrategies } from "../domain/strategies";
import { ICreateManyStrategy } from "../domain/strategies/base/creation.strategy";

export class DoorHardwareStrategyRegistry {
    private strategies = new Map<string, Constructor<ICreateManyStrategy>>();

    // prettier-ignore
    constructor() {
        this.register(SingleSwingDoors as DoorType[], DoorHardwareCreationStrategies.SingleSwingDoorHardwareStrategy);
        this.register(SingleSlidingDoors as DoorType[], DoorHardwareCreationStrategies.SingleSlidingDoorHardwareStrategy);
        this.register(DoubleSwingDoors as DoorType[], DoorHardwareCreationStrategies.DoubleSwingDoorHardwareStrategy);
        this.register(DoubleSlidingDoors as DoorType[], DoorHardwareCreationStrategies.DoubleSlidingDoorHardwareStrategy);
        this.register([KompasSingleFramedDoorCode] as DoorType[], DoorHardwareCreationStrategies.KompasSingleDoorHardwareStrategy);
        this.register([KompasDoubleFramedDoorCode] as DoorType[], DoorHardwareCreationStrategies.KompasDoubleDoorHardwareStrategy);
        this.register([SteelSingleSwingDoorCode] as DoorType[], DoorHardwareCreationStrategies.SteelSingleSwingDoorHardwareStrategy);
        this.register([SteelDoubleSwingDoorsCode] as DoorType[], DoorHardwareCreationStrategies.SteelDoubleSwingDoorHardwareStrategy);
        this.register([SteelSingleSlidingDoorCode] as DoorType[], DoorHardwareCreationStrategies.SteelSingleSlidingDoorHardwareStrategy);
        this.register([SteelDoubleSlidingDoorsCode] as DoorType[], DoorHardwareCreationStrategies.SteelDoubleSlidingDoorHardwareStrategy);
        this.register([SteelMultiSlidingDoorsCode] as DoorType[], DoorHardwareCreationStrategies.SteelMultiSlidingDoorHardwareStrategy);
        this.register([SteelFoldingDoorsCode] as DoorType[], DoorHardwareCreationStrategies.SteelFoldingDoorHardwareStrategy);
        this.register([SteelArchSingleSwingDoorCode] as DoorType[], DoorHardwareCreationStrategies.SteelArchSingleDoorHardwareStrategy);
        this.register([SteelArchDoubleSwingDoorsCode] as DoorType[], DoorHardwareCreationStrategies.SteelArchDoubleDoorHardwareStrategy);
    }

    getStrategy = (
        doorCode: DoorType,
    ): Constructor<ICreateManyStrategy> | null => {
        return this.strategies.get(doorCode) || null;
    };

    private register = (
        doorTypes: DoorType[],
        strategy: Constructor<ICreateManyStrategy>,
    ) => {
        for (const doorType of doorTypes) {
            this.strategies.set(doorType, strategy);
        }
    };
}
